export type PromptCategory = "animals" | "food" | "travel" | "movies" | "random";

export const PROMPTS: Record<PromptCategory, string[]> = {
  animals: [
    "Name a 3-letter animal",
    "Name an animal that lives in the ocean",
    "Name a pet that isn't a cat or dog",
    "Name an animal you'd be afraid to meet in the wild",
    "Name a black-and-white animal",
    "Name an animal that can fly but isn't a bird",
    "Name a farm animal",
    "Name an animal in a Disney movie",
    "Name a really fast animal",
    "Name an animal that hibernates",
    "Name an extinct animal",
    "Name an animal with stripes",
  ],
  food: [
    "Name a pizza topping",
    "Name a breakfast food",
    "Name a green vegetable",
    "Name an ice cream flavor",
    "Name a food that's better cold",
    "Name something you'd find in a sandwich",
    "Name a fast food chain",
    "Name a food eaten with chopsticks",
    "Name a comfort food",
    "Name a yellow food",
    "Name something you'd grill",
    "Name a soup",
  ],
  travel: [
    "Name a European capital",
    "Name a country in Asia",
    "Name an airline",
    "Name a beach destination",
    "Name a city you'd love to visit",
    "Name a famous landmark",
    "Name something you always pack",
    "Name an island country",
    "Name a national park",
    "Name a US state",
    "Name a tropical fruit",
    "Name a mode of transport",
  ],
  movies: [
    "Name a Pixar movie",
    "Name a movie with a number in the title",
    "Name a superhero movie",
    "Name an actor named Chris",
    "Name a movie villain",
    "Name a movie set in space",
    "Name a movie you've seen 3+ times",
    "Name a black-and-white movie",
    "Name a Christmas movie",
    "Name a movie based on a book",
    "Name a movie franchise",
    "Name an animated movie",
  ],
  random: [
    "Name a color that isn't on a rainbow",
    "Name something in your pocket",
    "Name a board game",
    "Name a sport played with a ball",
    "Name a musical instrument",
    "Name something you'd find in a bathroom",
    "Name a famous scientist",
    "Name a brand of phone",
    "Name a programming language",
    "Name a word that rhymes with 'time'",
    "Name a holiday",
    "Name something round",
  ],
};

export function getRandomPrompt(category?: PromptCategory): string {
  const cats = category && category !== "random" ? [category] : (Object.keys(PROMPTS) as PromptCategory[]);
  const cat = cats[Math.floor(Math.random() * cats.length)];
  const pool = PROMPTS[cat];
  return pool[Math.floor(Math.random() * pool.length)];
}
